import React, { useEffect, useState } from "react";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { DateHelper } from "@/app/core/util/helpers/DateHelper";
import ComplainCard from "./components/ComplainCard";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { ComplainHelper } from "@/app/core/util/helpers/ComplainHelper";
import { Tab, Tabs } from "react-bootstrap";

export default function UsersControlPanel() {
    const date = new Date();
    const [startDate, setStartDate] = useState(DateHelper.GetFirstDayOfMonth(
        date.getFullYear(), 
        date.getMonth() > 0 ? date.getMonth()-1 : date.getMonth()));
    const [endDate, setEndDate] = useState(DateHelper.GetLastDayOfMonth(
        date.getFullYear(), 
        date.getMonth() < 11 ? date.getMonth()+1 : date.getMonth()));
    const [data, setData] = useState([]);
    const [deleted, setDeleted] = useState([]);
    const [raw, setRaw] = useState([]);
    const [pages, setPages] = useState(1);

    useEffect(() => {
        loadData();
    }, [startDate, endDate]);


    async function loadData() {
        const total = await ComplainController.GetTotalCount() / 100;
        if (total > 1) {
            setPages(total)
        }
        console.log("consulta", new Date(startDate), new Date(endDate));
        let res = await ComplainController.ListByDate(new Date(startDate), new Date(endDate));
        let userIds = [];
        let companyIds = [];
        
        for(let s of res){
            if(s.userId)
                userIds.push(s.userId);
            if(s.companyId)
                companyIds.push(s.companyId);
        }
        
        const users = await AccountController.QueryUsers(userIds)
        const companies = await CompanyController.QueryCompanies(companyIds)
        
        for(let s of res){
            if(users){
                const current = users.filter(x => x.uid == s.userId);
                if(current.length > 0){
                    s.user = current[0];
                }
            }
            if(companies){
                const current = companies.filter(x => x.id == s.companyId);
                if(current.length > 0){
                    s.company = current[0];
                    console.log("achou", companies, s.company);
                }
            }
        }

        res.sort(function (a, b) {
            return b.createdDate.seconds - a.createdDate.seconds;
        });

        setData(res.filter(x => x.status !== ComplainHelper.Status.Deleted));
        setRaw(res.filter(x => x.status !== ComplainHelper.Status.Deleted));
        setDeleted(res.filter(x => x.status === ComplainHelper.Status.Deleted));

    }

    function handleChange(evt) {
        const inputValue = evt.target.value;
        if (inputValue === "") {
            setData(raw);
            return;
        }

        let newResults = [];
        for (let item of raw) {
            const title = item.title?.toLowerCase();
            const description = item.description?.toLowerCase();
            if (title.includes(inputValue) || description.includes(inputValue)) {
                newResults.push(item);
            }
            setData(newResults);
        }
    }

    function formatDate(date) {
        if((date + "").includes("T")){
            return date.toISOString().split("T")[0];
        }else{
            return date;
        }
    }

    return (
        <>
            <div className="content">
                <div className="row">
                    <div className="col-md-6">
                        <div className="content-heading">
                            <h3>Reclamações</h3>
                        </div>
                    </div>
                    <div className="col-md-6 row">
                        <div className="form-group col-md-4">
                            <span>Data de início</span>
                            <input
                                type="date"
                                className="form-control"
                                value={formatDate(startDate)}
                                onChange={(evt) => setStartDate(evt.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <span>Data fim</span>
                            <input
                                type="date"
                                className="form-control"
                                value={formatDate(endDate)}
                                onChange={(evt) => setEndDate(evt.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <div className="input-group mt-3">
                                <input
                                    type="text"
                                    onChange={(evt) => handleChange(evt)}
                                    className="form-control form-control"
                                    placeholder="Pesquisar..."
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text border-0 bg-body">
                                        <i className="fa fa-fw fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <Tabs defaultActiveKey={1}>
                            <Tab eventKey={1} title={data && `(${data.length}) Reclamações`}>
                                {data && data.map(item => (
                                    <ComplainCard data={item} reload={()=> loadData()}/>
                                ))}
                            </Tab>
                            <Tab eventKey={2} title={deleted && `(${deleted.length}) Excluídas`}>
                                {deleted && deleted.map(item => (
                                    <ComplainCard data={item} reload={()=> loadData()}/>
                                ))}
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </>
    );
}
